import React from 'react';
import { MemberItemController } from './memberItemInterface';
import { EnumMemberItemContainerProps } from './memberItemProps';

export function createMemberItemContainer(
    controller: MemberItemController
): React.FC<EnumMemberItemContainerProps> {
    return ({ as: View, ...containerProps }) => {
        const props = controller.useProps({ ...containerProps });
        return <View {...props} />;
    };
}
